module.exports = __webpack_public_path__ + "static/media/logo.eb8a797b.svg";